import { FC, Fragment } from "react";
import { Link } from "react-router-dom";
import { Popover, Transition } from "@headlessui/react";
import { Bars3Icon, XMarkIcon } from "@heroicons/react/24/outline";
import { nanoid } from "nanoid";

import LogoImg from "assets/images/logo/logo.png";

import { NAV_PATHS } from "constants/paths";

export const Navbar: FC = () => {
	const navItems = [
		{
			name: "Home",
			url: NAV_PATHS.HOMEPAGE,
		},
		{
			name: "About Us",
			url: NAV_PATHS.ABOUT,
		},
		{
			name: "Our Team",
			url: NAV_PATHS.TEAM,
		},
		{
			name: "Our Services",
			url: NAV_PATHS.SERVICES,
		},
		{
			name: "Contact Us",
			url: NAV_PATHS.CONTACT,
		},
	];

	const LogoAlt = "Official logo for View Limited";

	return (
		<Popover className='relative top-0 bg-white'>
			<div
				className='pointer-events-none absolute inset-0 z-30 shadow'
				aria-hidden='true'
			/>
			<div className='relative z-20'>
				<div className='mx-auto flex max-w-7xl items-center justify-between px-4 py-5 sm:px-6 sm:py-4 md:space-x-10 lg:px-8'>
					<div>
						<Link to={NAV_PATHS.HOMEPAGE} className='flex'>
							<span className='sr-only'>View Limited</span>
							<img className='h-8 w-auto sm:h-10' src={LogoImg} alt={LogoAlt} />
						</Link>
					</div>
					<div className='-my-2 -mr-2 md:hidden'>
						<Popover.Button className='inline-flex items-center justify-center rounded-md bg-white p-2 text-gray-400 hover:bg-gray-100 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500'>
							<span className='sr-only'>Open menu</span>
							<Bars3Icon className='h-6 w-6' aria-hidden='true' />
						</Popover.Button>
					</div>
					<div className='hidden md:flex md:flex-1 md:items-center md:justify-between '>
						<div className='flex gap-10'>
							{navItems.map((nav) => (
								<Link
									className='text-base font-medium text-gray-500 hover:text-gray-900'
									key={nanoid()}
									to={nav.url}
								>
									{nav.name}
								</Link>
							))}
						</div>
					</div>
				</div>
			</div>

			<Transition
				as={Fragment}
				enter='duration-200 ease-out'
				enterFrom='opacity-0 scale-95'
				enterTo='opacity-100 scale-100'
				leave='duration-100 ease-in'
				leaveFrom='opacity-100 scale-100'
				leaveTo='opacity-0 scale-95'
			>
				<Popover.Panel
					focus
					className='absolute inset-x-0 top-0 z-30 origin-top-right transform p-2 transition md:hidden'
				>
					<div className='divide-y-2 divide-gray-50 rounded-lg bg-white shadow-lg ring-1 ring-black ring-opacity-5'>
						<div className='px-5 pt-5 pb-6 sm:pb-8'>
							<div className='flex items-center justify-between'>
								<div>
									<img className='h-8 w-auto' src={LogoImg} alt={LogoAlt} />
								</div>
								<div className='-mr-2'>
									<Popover.Button className='inline-flex items-center justify-center rounded-md bg-white p-2 text-gray-400 hover:bg-gray-100 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500'>
										<span className='sr-only'>Close menu</span>
										<XMarkIcon className='h-6 w-6' aria-hidden='true' />
									</Popover.Button>
								</div>
							</div>
						</div>
						<div className='py-6 px-5'>
							<div className='grid grid-cols-2 gap-4'>
								{navItems.map((nav) => (
									<Link
										className='rounded-md text-base font-medium text-gray-900 hover:text-gray-700'
										key={nanoid()}
										to={nav.url}
									>
										{nav.name}
									</Link>
								))}
							</div>
						</div>
					</div>
				</Popover.Panel>
			</Transition>
		</Popover>
	);
};
